import { useTranslation } from 'i18n';
import { Fragment } from 'react';
import { CenteredLoader, Typography } from 'ui';

import { useSiteMaterialsBySite } from '../../hooks/useSiteMaterialsBySite/useSiteMaterialsBySite';
import { SiteMaterialsList } from '../SiteMaterialsList/SiteMaterialsList';

export const CompanySites = ({ tradeCompanyId }: { tradeCompanyId: number }) => {
  const { t } = useTranslation('orders');
  const { data, isLoading } = useSiteMaterialsBySite(tradeCompanyId);

  if (isLoading) {
    return <CenteredLoader />;
  }

  if (!data) {
    return <Typography>{t('siteMaterials.companySites.noMaterialsFoundForCompany')}</Typography>;
  }

  return (
    <div>
      {data.map((siteMaterials, index) => (
        <Fragment key={`siteMaterials-${index}`}>
          <SiteMaterialsList
            key={siteMaterials[0].site.id}
            siteMaterials={siteMaterials}
            siteName={siteMaterials[0].site.full_address}
          />
        </Fragment>
      ))}
    </div>
  );
};
